import { useTranslation } from "react-i18next";
import { useTheme } from "../../contexts/Theme";
import { IconInfo, IconExpandLess, IconExpandMore } from 'cdk-radial';
import { UserCardsContainer, UserCardsHeader } from "./UserCardStyles"
import { useEffect, useState } from "react";
import { useDepartmentList, useUnifyUserProfile, useUserCards, useUserProfile } from "../../hooks/queries";
import { CardMenu } from "../Cards/BaseCard";
import { useShowDialog } from '../../contexts/AppStateContext';
import { UserCardsList } from "./UserCardsList";
import WorkflowContainer from "../WorkflowContainer/WorkflowContainer";
import { RoundedIconButton } from "../Buttons/IconButton";
import { useFeatureFlag } from '@harnessio/ff-react-client-sdk'
import { getActiveLinks } from "../../util/getActiveLinks";

export interface CustomApps {
    apps: UserCard[];
    loginId?: string;
    enterpriseId?: string;
}

export interface UserCard {
    name?: string;
    description?: string;
    url?: string;
    iconText?: string;
    appId?: string;
    loginId?: string;
    enterpriseId?: string
}

export function UserCards() {
    const {t} = useTranslation();
    const menuOptions = [
        { label: t('baseCard.menu.learnMore'), key:'LEARN_MORE',  icon: <IconInfo /> },
    ];
    const { darkMode } = useTheme();
    const { data: userUnifyProfile } = useUnifyUserProfile();
    const departmentTypes = userUnifyProfile?.departmentTypes;
    const {data: userProfile} = useUserProfile();
    const { data: userCards } = useUserCards(userProfile?.userProfile?.enterpriseId || "");
    const { data: departmentList } = useDepartmentList();
    const [ userCardList, setUserCardList ] = useState<CustomApps>();
    const showDialog = useShowDialog();
    const userCustomCardsFeature = useFeatureFlag('UNIFY_UI_CUSTOM_CARDS');
    const [ isExpanded, setIsExpanded ] = useState(true);

    useEffect( () => {
        userCards && setUserCardList(userCards);
    }, [userCards] );

    const menuHandler = (option: CardMenu, {iconText, description, name, url, appId}: UserCard) => {
        switch(option.key) {
            case 'LEARN_MORE':
                showDialog('LEARN_MORE', {
                    iconColor: "#000",
                    iconText,
                    name,
                    description,
                    isEnabled: true,
                    showDescription: true,
                });
                break;
        }
    }


    const acitveLinks = getActiveLinks(userCardList, departmentTypes, departmentList);

    return (
        <>
            {userCustomCardsFeature && userCardList && acitveLinks?.length > 0 ?
                <UserCardsContainer>
                    <WorkflowContainer isExpanded={isExpanded} darkMode={darkMode} closedHeight={"36px"}>
                        <UserCardsHeader>
                            <span style={{ paddingRight: "20px" }}>{t('myUnifyTab.myCards')} </span>
                            <RoundedIconButton
                                dataTestId="expand-user-cards"
                                icon={
                                    isExpanded ? (
                                        <IconExpandLess />
                                    ) : (
                                        <IconExpandMore />
                                    )
                                }
                                style={{ marginLeft: 'auto' }}
                                darkMode={darkMode}
                                onClick={() => setIsExpanded(!isExpanded)}
                                text=""
                            />
                        </UserCardsHeader>
                        <UserCardsList userCardList={userCardList} menuOptions={menuOptions} menuHandler={menuHandler} />
                    </WorkflowContainer>
                </UserCardsContainer> : null
            }
        </>
    )
}
